import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { BaseComponent } from 'src/app/common/components/base/base.component';
import { ClientConfigService } from 'src/app/common/services/client-config.service';
import { FunctionsService } from 'src/app/common/services/functions.service';
import { CoreResponseStatus } from 'src/app/contracts/responseMessage/coreResponseMessage';
import { LoginService } from 'src/app/managers/login.service';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent extends BaseComponent implements OnInit, OnDestroy {
  email: string;
  password: string;
  confirmPassword: string;

  constructor(route: ActivatedRoute, loginManager: LoginService, clientConfig: ClientConfigService, dialog: MatDialog, 
              private _functionsService: FunctionsService, private _snackBar: MatSnackBar, private dialogRef: MatDialogRef<AppComponent>,
              @Inject(MAT_DIALOG_DATA) private _data: any) { 
    super(route, loginManager, clientConfig, dialog);
  }

  ngOnInit() {
    super.ngOnInit();
    this.email = this._data.dataSource.Email;
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  enableUpdateButton(): boolean {
    let enable = false;

    if (!this.undefinedOrNull(this.email) && this.email.length > 0) {
      if (!this.undefinedOrNull(this.password) && this.password.length > 0) {
        if (!this.undefinedOrNull(this.confirmPassword) && this.confirmPassword.length > 0)
          enable = true;
      }
    }

    return enable;
  }

  async updateUser() {
    if (this.password !== this.confirmPassword) {
      this.openAlertDialog('Update Profile', "Passwords don't match.", '350px', '200px');
      return;
    }

    this._snackBar.open('Updating profile. Please wait...');
    let responseMsg = await this.loginManager.updateSelfAsync(this.email, this.password);
    this._snackBar.dismiss();

    if (responseMsg.Status === CoreResponseStatus.OK) {
      this._snackBar.open('Your profile updated successfully.', 'OK', { duration: this._successMsgDuration });
      this.dialogRef.close(responseMsg.Result);
    }
    else {
      this.openAlertDialog('Update Profile', 'Failed to update: ' + responseMsg.Message, '350px', '250px');
      this.dialogRef.close(null);
    }
  }

  close() {
    this.dialogRef.close(null);
  }
}
